import { SubjectManager } from "@/utils/subject-manager.js";

export const iotEventsService = new SubjectManager();
